<template>
  <div class="nav-links">
    <NavLink v-for="link in gameLinks" :key="link.name" :link="link" />
  </div>
</template>

<script>
import NavLink from "./NavLink"
import { NAV_LINKS } from "@/constants/navbar"
import { mapGetters } from "vuex"

export default {
  components: {
    NavLink,
  },
  computed: {
    ...mapGetters("User", ["currentActiveGame", "getUser"]),
    gameLinks () {
      if (this.getUser) {
        return NAV_LINKS[this.currentActiveGame]
      }
      const activeGame = window.localStorage.getItem("active_game")
      if (activeGame) {
        return NAV_LINKS[activeGame]
      } else {
        return NAV_LINKS["leagueoflegends"]
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.nav-links {
  display: flex;
  @include desktop-down {
    flex-direction: column;
    margin-left: 2rem;
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavLinks.vue